import { QueryClient } from "@tanstack/react-query";

/**
 * Tek QueryClient instance'ı. AppProviders içinde QueryClientProvider'a verilir.
 *
 * Defaults:
 *   - staleTime: 60s — sayfa geçişi sırasında refetch'i önler
 *   - gcTime:    5dk — unmounted query'ler 5dk cache'te kalır
 *   - retry:     1 — bir kere yeniden dene; sunucu down ise hızlıca hata göster
 *   - refetchOnWindowFocus: false — agresif refetch kapalı (UI titremesin)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
